import { Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import Buttons from "../../../../library/custom/button/Button";
import { ORG_ID, ORG_NAME, SW3RD_PARTY_INSPECTOR, USER_ID } from "../../../../constant/constant";
import FormControl from "@mui/material/FormControl";
import { useNavigate } from "react-router-dom";
import { InputField } from "../../../../library/custom/textBox/InputField";
import SelectMenu from "../../../../library/custom/selectMenu/SelectMenu";
import FormLabels from "../../../../library/custom/formLabel/FormLabels";
import DatePickers from "../../../../library/custom/datePicker/DatePicker";
import BackBtn from "../../../../library/custom/backBtn/backBtn";
import {
  ADMIN_ADD_STORM_WATERPROJECT,
  ADMIN_RESOURCE,
  ADMIN_SW_VIEW_PROJECT,
  INSPECTION_AUTHORITY,
  SETUP_INSPECTION,
  SETUP_INSPECTION_LIST,
  SW_ADMIN_SAMPLINGLOG,
  SW_CONTACT_PROJECT,
  SW_INSPECTION_LIST,
  SW_OPEN_ITEMS,
  SW_PERMIT_LIST,
  SW_RAIN_FALL_DATA,
} from "../../../../constant/routeContant";
import ToolBar from "../../../../library/storm-water/toolBar";
import {
  dateValiadtor,
  getFormatedDate,
  InactiveClient,
  parseDate,
} from "../../../../utils/helper";
import { checkPrivileges, hasAllPrivileges } from "../../../../utils/rolesHelper";
import FormDropZone from "../../../../library/dropZone/FormDropZone";

function AddPermit({
  projectid,
  editMode,
  onSubmit,
  permitId,
  permitDetails,
  getPermitType,
  stateId,
  Projectstate,
  projectNumber,
  projectName,
  clearAddPermit,
  customer,
  customerId,
  uploadContractorSignatureFile,
  fileUploadData,
  selectedClientSignature,
  setSelectedClientSignature,
  handleDeleteSignature,
  handlePermitType,
}) {
  const customerName = customer ?? ORG_NAME();
  const navigate = useNavigate();

  const toolBarData = {
    title: "Project Tools",

    list: [
      {
        id: 13,
        title: "View Project",
        link: "",
        isshow: checkPrivileges([12, 113, 111, 112]),
      },
      {
        id: 10,
        title: "Edit Project",
        link: "",
        isshow: checkPrivileges([12, 111, 112]),
      },
      {
        id: 1,
        title: "Project Contacts",
        link: "",
        isshow: checkPrivileges([12, 132, 133, 134]),
      },
      {
        id: 2,
        title: "Inspection Service List",
        link: "",
        isshow: checkPrivileges([12, 99, 100, 101]),
      },
      {
        id: 9,
        title: "Setup Inspections",
        link: "",
        isshow: checkPrivileges([12, 99, 100]),
      },
      {
        id: 3,
        title: "Permits",
        link: "",
        isshow: checkPrivileges([12, 126, 127, 128]),
      },

      {
        id: 4,
        title: "Sampling Log",
        link: "",
        isshow: checkPrivileges([12, 129, 130, 131]),
      },
      {
        id: 5,
        title: "Open Items",
        link: "",
        isshow: checkPrivileges([12, 105, 106, 107]),
      },
      {
        id: 6,
        title: "Rainfall Data",
        link: "",
        isshow: !hasAllPrivileges(SW3RD_PARTY_INSPECTOR),
      },
      {
        id: 7,
        title: "Inspection Records",
        link: "",
        isshow: checkPrivileges([12, 102, 103, 104]),
      },

      {
        id: 8,
        title: "Inspection Authority",
        link: "",
        isshow: checkPrivileges([12, 96, 97, 98]),
      },
    ],
  };
  const initialState = {
    stateId: stateId,
    projectId: 0,
    permitteeTypeId: 0,
    holderName: "",
    permitNumber: "",
    approvalDate: null,
    expirationDate: null,
    isUsedExpirationDate: false,
    documentUrl: "string",
    address: "",
    createdBy: parseInt(USER_ID()),
  };

  const [permitTypeError, setPermitTypeError] = useState(false);
  const [isPermitNumber, setIsPermitNumber] = useState(false);
  const [formValue, setFormValue] = useState(initialState);
  const generalPermitExpDate = parseDate(
    getPermitType?.genPermitExpDate,
    "MM-dd-yyyy"
  );
  const [approvalDateErrMsg, setApprovalDateErrMsg] = useState(false);
  const [expireDateErrMsg, setExpireDateErrMsg] = useState(false);

  function mappedData() {
    let data;
    if (editMode) {
      data = {
        stateId: stateId,
        projectId: projectid,
        permitteeTypeId: parseInt(formValue.permitteeTypeId),
        holderName: formValue.holderName,
        address: formValue.address,
        permitNumber: formValue.permitNumber,
        approvalDate:
          formValue.approvalDate === null
            ? null
            : getFormatedDate(formValue.approvalDate),
        expirationDate:
          formValue.expirationDate === null
            ? null
            : getFormatedDate(formValue.expirationDate),
        sitePermitExpirationDate:
          generalPermitExpDate === null
            ? null
            : getFormatedDate(generalPermitExpDate),
        isUsedExpirationDate: formValue.isUsedExpirationDate,
        documentUrl: formValue.fileUrls,
        permitId: permitId,
        modifiedBy: parseInt(USER_ID()),
        createdBy: parseInt(USER_ID()),
        signatureUrl: selectedClientSignature,
        orgId: customerId,
      };
    } else {
      data = {
        stateId: parseInt(formValue.stateId),
        projectId: projectid,
        permitteeTypeId: parseInt(formValue.permitteeTypeId),
        holderName: formValue.holderName,
        address: formValue.address,
        permitNumber: formValue.permitNumber,
        approvalDate: getFormatedDate(formValue.approvalDate),
        expirationDate: getFormatedDate(formValue.expirationDate),
        sitePermitExpirationDate:
          generalPermitExpDate === null
            ? null
            : getFormatedDate(generalPermitExpDate),
        isUsedExpirationDate: formValue.isUsedExpirationDate,
        documentUrl: formValue.fileUrls,
        createdBy: parseInt(USER_ID()),
        signatureUrl: selectedClientSignature,
        orgId: customerId,
      };
    }

    let errors = false;
    if (formValue.permitteeTypeId === 0) {
      setPermitTypeError(true);
      errors = true;
    }
    if (formValue?.permitNumber.trim() === "") {
      setFormValue({ ...formValue, permitNumber: "" });
      setIsPermitNumber(true);
      errors = true;
    }
    if (formValue?.approvalDate) {
      const validDate = dateValiadtor(getFormatedDate(formValue?.approvalDate));
      if (validDate === false) {
        setApprovalDateErrMsg(true);
        errors = true;
      } else if (validDate === "Valid date") {
        setApprovalDateErrMsg(false);
      }
    }
    if (formValue?.expirationDate) {
      const validDate = dateValiadtor(
        getFormatedDate(formValue?.expirationDate)
      );
      if (validDate === false) {
        setExpireDateErrMsg(true);
        errors = true;
      } else if (validDate === "Valid date") {
        setExpireDateErrMsg(false);
      }
    }

    if (errors) {
      return false;
    }

    return data;
  }

  const history = useNavigate();

  const dataBack = {
    title: "Back to Project Permit",
    route: SW_PERMIT_LIST,
    projectName: projectName,
    projectNumber: projectNumber,
    projectid: projectid,
    customerName: customerName,
    customerId: customerId,
    stateId: parseInt(formValue.stateId),
  };
  const submitData = () => {
    if (InactiveClient()) return;
    const data = mappedData();
    if (!data) {
    } else {
      editMode ? onSubmit(data) : onSubmit(data);
    }
  };

  const handleDeleteImageURL = () => {
    setFormValue({
      ...formValue,
      fileUrls: "",
    });
  };

  const [resourceFilesData, setResourceFilesData] = useState("");
  useEffect(() => {
    formValue.fileUrls = resourceFilesData;
    setFormValue({ ...formValue });
  }, [resourceFilesData]);

  useEffect(() => {
    if (fileUploadData) {
      setSelectedClientSignature(fileUploadData?.files[0]?.filePath);
    }
  }, [fileUploadData]);

  const handleFileChange = (files, single) => {
    setResourceFilesData(files);
  };

  useEffect(() => {
    if (permitDetails) {
      setFormValue({
        stateId: permitDetails?.stateId,
        projectId: permitDetails?.projectId,
        permitteeTypeId: permitDetails?.permitteeTypeId,
        holderName: permitDetails?.holderName,
        address: permitDetails?.address,
        permitNumber: permitDetails?.permitNumber,
        approvalDate: parseDate(permitDetails?.approvalDate, "MM-dd-yyyy"),
        expirationDate: parseDate(permitDetails?.expirationDate, "MM-dd-yyyy"),
        sitePermitExpirationDate: parseDate(
          permitDetails?.sitePermitExpirationDate,
          "MM-dd-yyyy"
        ),
        checkBox: permitDetails?.isUsedExpirationDate,
        fileUrls: permitDetails?.documentUrl,
        createdBy: permitDetails?.createdBy,
      });
      setSelectedClientSignature(permitDetails?.signatureUrl);
    }
  }, [permitDetails]);

  // useEffect(()=>{
  //   if(formValue?.stateId){
  //     const data1 = {
  //       stateId: formValue.stateId,
  //     };
  //     handlePermitType(data1)
  //   }
  // },[formValue.stateId])

  return (
    <>
      <section className="grid_main_sec sw">
        <div className="grid_main_header two_grid">
          <div className="grid_heading_style">
            {editMode ? "Edit Project Permit" : "Add Project Permit"}
          </div>
        </div>

        <Grid container>
          <Grid lg={8} md={12} xs={12} pr={2}>
            {editMode ? (
              <Grid item lg={6} xs={12} sm={12} md={6}>
                <FormControl fullWidth>
                  <InputField
                    isRequired={true}
                    fullWidth={true}
                    disabled={true}
                    type="text"
                    label="Permit ID"
                    value={permitId}
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        equipmentID: e.target.value,
                      })
                    }
                  />
                </FormControl>
              </Grid>
            ) : (
              ""
            )}
            <Grid container spacing={2} mt={2}>
              <Grid item lg={6} xs={12} sm={12} md={6}>
                <FormControl fullWidth>
                  <FormLabels label="Permit Type" isRequired={true} />
                  <SelectMenu
                    listData={getPermitType?.permitType}
                    value={formValue.permitteeTypeId}
                    placeholder="Please Select"
                    onchangehandler={(e) => {
                      const selectedValue = String(e.target.value); // Convert to string
                      setFormValue({
                        ...formValue,
                        permitteeTypeId: e.target.value,
                      });
                    }}
                    isError={permitTypeError}
                    errorMsg={permitTypeError ? "PermitType is Required" : ""}
                  />
                </FormControl>
              </Grid>
              <Grid item lg={6} xs={12} sm={12} md={6}>
                <FormControl fullWidth>
                  <InputField
                    isRequired={false}
                    type="text"
                    label="Permit Enforcement"
                    placeholder={"Add Permit Enforcement..."}
                    value={formValue?.holderName}
                    onChange={(e) => {
                      if (
                        e.target.value === " " &&
                        formValue.holderName.trim() === ""
                      )
                        setFormValue({
                          ...formValue,
                          holderName: "",
                        });
                      else
                        setFormValue({
                          ...formValue,
                          holderName: e.target.value,
                        });
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item lg={6} xs={12} sm={12} md={6}>
                <FormControl fullWidth>
                  <InputField
                    isRequired={false}
                    type="text"
                    label="Permittee Address"
                    placeholder={"Add Permittee Address..."}
                    value={formValue?.address}
                    onChange={(e) => {
                      if (
                        e.target.value === " " &&
                        formValue.address.trim() === ""
                      )
                        setFormValue({
                          ...formValue,
                          address: "",
                        });
                      else
                        setFormValue({
                          ...formValue,
                          address: e.target.value,
                        });
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item lg={6} xs={12} sm={12} md={6}>
                <FormControl fullWidth>
                  <InputField
                    isRequired={true}
                    type="text"
                    label={"Permit Number"}
                    value={formValue.permitNumber}
                    placeholder={"Add Permit Number..."}
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        permitNumber: e.target.value,
                      })
                    }
                    isError={isPermitNumber}
                    errorMsg={
                      isPermitNumber ? "Permit Number  is required" : ""
                    }
                  />
                </FormControl>
              </Grid>

              <Grid item lg={6} xs={12} sm={12} md={6}>
                <FormControl fullWidth>
                  <FormLabels
                    label={"Permit Approval Date"}
                    isRequired={false}
                  />
                  <DatePickers
                    maxDateEnable={true}
                    value={formValue.approvalDate}
                    onChangeHandler={(e) => {
                      setFormValue({
                        ...formValue,
                        approvalDate: e,
                      });
                      setApprovalDateErrMsg(false);
                    }}
                  />
                </FormControl>
                {approvalDateErrMsg && formValue.approvalDate != null && (
                  <div className="errorMsg">Invalid Date</div>
                )}
              </Grid>
              <Grid item lg={6} xs={12} sm={12} md={6}>
                <FormControl fullWidth>
                  <FormLabels
                    label={"General Permit Expiration Date"}
                    isRequired={false}
                  />
                  <DatePickers
                    maxDateEnable={true}
                    value={generalPermitExpDate}
                    disabled={true}
                  />
                </FormControl>
              </Grid>

              <Grid item lg={6} xs={12} sm={12} md={6}>
                <FormControl fullWidth>
                  <FormLabels
                    label={"Permit Expiration Date"}
                    isRequired={false}
                  />
                  <DatePickers
                    maxDateEnable={true}
                    value={formValue.expirationDate}
                    onChangeHandler={(e) => {
                      setFormValue({
                        ...formValue,
                        expirationDate: e,
                      });
                      setExpireDateErrMsg(false);
                    }}
                  />
                </FormControl>
                {expireDateErrMsg && formValue.expirationDate != null && (
                  <div className="errorMsg">Invalid Date</div>
                )}
              </Grid>
            </Grid>

            <Grid container mt={5}>
              <Grid
                item
                lg={12}
                xs={12}
                sm={12}
                md={12}
                className="permitFileUpload"
              >
                <FormDropZone
                  label={"Add Permit"}
                  paraText1={"Drop the files here ..."}
                  paraText2={"Drop document/image here, "}
                  paraText3={"or Browse"}
                  handleFileChange={handleFileChange}
                  fileType={10}
                  imageUrl={formValue.fileUrls}
                  deleteImageURL={(url) => handleDeleteImageURL(url)}
                  id="addResources"
                  key="addResources"
                  isMuliple={false}
                  isDoc={true}
                  isImage={false}
                  allFiles={true}
                  isRequired={false}
                />
              </Grid>
            </Grid>

            <Grid container item mt={3}>
              <Grid item lg={6} md={12} xs={12}>
                <div className="">
                  <BackBtn dataBack={dataBack} />
                </div>
              </Grid>
              <Grid item lg={6} xs={12} md={12} mt={2.2}>
                <Grid container item lg={12} xs={12} className="divisionBtnBox">
                  <Grid lg={6} xs={12} sm={6} mt={0.5}>
                    <Buttons
                      varientText={true}
                      label="Cancel"
                      onClick={() => history(-1)}
                    />
                  </Grid>

                  <Grid lg={6} xs={12} sm={6} md={4}>
                    <Buttons
                      varientContained={true}
                      label={editMode ? "Update" : "Save"}
                      onClick={submitData}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid lg={4} md={12} xs={12} pl={1} className="permitsTootBar">
            <div className="toolBarBox">
              <div className="otherDetail">
                <h3>Projects Details</h3>
                <h2>{projectName}</h2>
                <h2>{projectNumber}</h2>
              </div>

              <div className="otherDetail">
                <h3>Client Name</h3>
                <h2>{customerName}</h2>
              </div>
              <ToolBar
                toolBarData={toolBarData}
                handleClick={(e) => {
                  if (e.id === 13) {
                    navigate(ADMIN_SW_VIEW_PROJECT, {
                      state: {
                        projectName: projectName,
                        projectNumber: projectNumber,
                        projectId: projectid,
                        customerName: customerName,
                        customerId: customerId
                          ? customerId
                          : parseInt(ORG_ID()),
                        stateId: stateId,
                      },
                    });
                  }
                  if (e.id === 1) {
                    navigate(SW_CONTACT_PROJECT, {
                      state: {
                        projectName: projectName,
                        projectNumber: projectNumber,
                        projectId: projectid,
                        customerName: customerName,
                        customerId: customerId
                          ? customerId
                          : parseInt(ORG_ID()),
                        stateId: stateId,
                      },
                    });
                  }
                  if (e.id === 2) {
                    navigate(SETUP_INSPECTION_LIST, {
                      state: {
                        projectName: projectName,
                        projectNumber: projectNumber,
                        projectId: projectid,
                        customerName: customerName,
                        customerId: customerId
                          ? customerId
                          : parseInt(ORG_ID()),
                        stateId: stateId,
                      },
                    });
                  }
                  if (e.id === 9) {
                    navigate(SETUP_INSPECTION, {
                      state: {
                        projectName: projectName,
                        projectNumber: projectNumber,
                        projectId: projectid,
                        customerName: customerName,
                        customerId: customerId
                          ? customerId
                          : parseInt(ORG_ID()),
                        stateId: stateId,
                        rightSideMode: true,
                      },
                    });
                  }
                  if (e.id === 3) {
                    navigate(SW_PERMIT_LIST, {
                      state: {
                        projectName: projectName,
                        projectNumber: projectNumber,
                        projectid: projectid,
                        customerName: customerName,
                        customerId: customerId
                          ? customerId
                          : parseInt(ORG_ID()),
                        stateId: stateId,
                      },
                    });
                  }
                  if (e.id === 4) {
                    navigate(SW_ADMIN_SAMPLINGLOG, {
                      state: {
                        projectName: projectName,
                        projectNumber: projectNumber,
                        projectId: projectid,
                        customerName: customerName,
                        customerId: customerId
                          ? customerId
                          : parseInt(ORG_ID()),
                        stateId: stateId,
                      },
                    });
                  }
                  if (e.id === 5) {
                    navigate(SW_OPEN_ITEMS, {
                      state: {
                        projectName: projectName,
                        projectNumber: projectNumber,
                        projectId: projectid,
                        customerName: customerName,
                        customerId: customerId
                          ? customerId
                          : parseInt(ORG_ID()),
                        stateId: stateId,
                      },
                    });
                  }
                  if (e.id === 6) {
                    navigate(SW_RAIN_FALL_DATA, {
                      state: {
                        projectName: projectName,
                        projectNumber: projectNumber,
                        projectId: projectid,
                        customerName: customerName,
                        customerId: customerId
                          ? customerId
                          : parseInt(ORG_ID()),
                        stateId: stateId,
                      },
                    });
                  }
                  if (e.id === 7) {
                    navigate(SW_INSPECTION_LIST, {
                      state: {
                        projectName: projectName,
                        projectNumber: projectNumber,
                        projectId: projectid,
                        customerName: customerName,
                        customerId: customerId
                          ? customerId
                          : parseInt(ORG_ID()),
                        stateId: stateId,
                      },
                    });
                  }
                  if (e.id === 8) {
                    navigate(INSPECTION_AUTHORITY);
                  }
                  if (e.id === 10) {
                    navigate(ADMIN_ADD_STORM_WATERPROJECT, {
                      state: {
                        editMode: true,
                        projectid: projectid,
                        projectName: projectName,
                        projectNumber: projectNumber,
                        customerName: customerName,
                        customerId: customerId
                          ? customerId
                          : parseInt(ORG_ID()),
                        stateId: stateId,
                      },
                    });
                  }
                  if (e.id === 12) {
                    navigate(ADMIN_RESOURCE, {
                      state: {
                        projectName: projectName,
                        projectNumber: projectNumber,
                        projectId: projectid,
                        customerName: customerName,
                        customerId: customerId
                          ? customerId
                          : parseInt(ORG_ID()),
                        stateId: stateId,
                      },
                    });
                  } else return;
                }}
              />
            </div>
          </Grid>
        </Grid>
      </section>
    </>
  );
}

export default AddPermit;
